import { render, staticRenderFns } from "./FullNameNotification.vue?vue&type=template&id=6b987c24&"
import script from "./FullNameNotification.vue?vue&type=script&lang=js&"
export * from "./FullNameNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports